window.bookingFlow = () => {
    return {
        open: false,
        treatments: [],
        selectedTreatment: null,
        showClubsPanel: false,
        error: false,

        handleModalOpen(event) {
            this.open = true;
            this.loadTreatments();  // Load treatments when the modal opens
        },

        handleModalClose() {
            this.open = false;
            this.showClubsPanel = false;
            this.selectedTreatment = null;

            document.body.classList.remove("modal-open");
        },

        loadTreatments() {
            fetch(`${ajaxurl}?action=get_treatments`)
                .then(response => response.json())
                .then(data => {
                    if (data.success) {
                        this.treatments = data.data.treatments;
                    } else {
                        this.error = true;
                    }
                })
                .catch(() => {
                    this.error = true;
                });
        },

        openClubsPanel(treatment) {
            this.selectedTreatment = treatment;
            this.showClubsPanel = true;
        },

        closeClubsPanel() {
            this.showClubsPanel = false;
            this.selectedTreatment = null;
        },
        
        // Listen for custom event and handle preselected treatment
        init() {
            this.$el.addEventListener('open-with-treatment', (event) => {
                this.openWithPreselectedTreatment(event.detail.treatmentName);
            });
        },

        openWithPreselectedTreatment(treatmentName) {
            this.open = true;
            this.loadTreatments();
            document.body.classList.add("modal-open");

            // Wait for treatments to load and find the treatment
            setTimeout(() => {
                const treatment = this.treatments.find(t => t.treatment_name === treatmentName);
                if (treatment) {
                    this.selectedTreatment = treatment;
                    this.showClubsPanel = true; 
                }
            }, 500); 
        }
    };
};

// Define the global function for dispatching the event
window.dispatchOpenTreatmentEvent = function(treatmentName) {
    const bookingFlowElement = document.querySelector('[x-data="bookingFlow()"]');
    
    if (bookingFlowElement) {
        console.log('Dispatching event to Alpine component');
        bookingFlowElement.dispatchEvent(new CustomEvent('open-with-treatment', {
            detail: { treatmentName: treatmentName },
            bubbles: true
        }));
    } else {
        console.error('Booking flow element not found');
    }
};
